<template>
  <v-btn
    color="secondary"
    class="text-capitalize"
    dark
    block
    rounded
    @click="$emit('update:status', yachtStatuses.INVESTMENT_STATUS_SALES)"
  >
    <v-icon
      left
      small
    >
      arrow_forward
    </v-icon>
    Switch to Sales
  </v-btn>
</template>

<script>
  import Yacht from '@/models/Yacht'

  export default {
    name: 'Draft',
    data() {
      return {
        yachtStatuses: Yacht
      }
    }
  }
</script>
